import { stepsContainer } from './CodeSteps.styles';

type Props = {
  stepNumnber: number;
  title: string | React.ReactNode;
  dropdown: React.ReactNode;
};

export const CodeSteps: React.FC<Props> = ({ stepNumnber, title, dropdown }) => {
  return (
    <div className={stepsContainer}>
      <div className="left">
        <div className="steps-number">{stepNumnber}</div>
        <div className="title">{title}</div>
      </div>
      <div className="right">{dropdown}</div>
    </div>
  );
};
